import React from "react";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillTwitterCircle
} from "react-icons/ai";
import { Container, Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";

export default function SocialMedia() {
  return (
    <div className="mt-4">
      <Zoom left cascade>
        <h1>Connect with me</h1>
      </Zoom>
      <Container className="mt-5 items-center">
        <Row className="g-5 justify-center">
          <Col md={3}>
            <a
              href="https://github.com/Prashant-Malviya"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
              <div className="flex justify-center items-center mt-4">
                <Zoom cascade>
                  <AiFillGithub />
                </Zoom>
              </div>
            </a>
          </Col>
          <Col md={3}>
            <a
              href="https://www.linkedin.com/in/prashant-malviya-57270b1b6/"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
             <div className="flex justify-center items-center mt-4">
                <Zoom cascade>
                  <AiFillLinkedin />
                </Zoom>
              </div>
            </a>
          </Col>

          <Col md={3}>
            <a
              href="https://x.com/Prashant_979"
              target="_blank"
              rel="noreferrer"
              className="icon-colour  home-social-icons"
            >
             <div className="flex justify-center items-center mt-4">
                <Zoom cascade>
                  <AiFillTwitterCircle />
                </Zoom>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
